import React, { FC, useEffect, useMemo, useState } from 'react'
import { default as ReactSelect } from "react-select";
import useFetchCountries from '../../hooks/useFetchCountries';
import MultiSelectOption from './MultiSelectOption';

type Props = {
  defaultValues: string | null;
  updateSelectedValue: (value: string) => void;
};

type CountryFilterOption = {
  value: number;
  label: string;
};

export const CountryFilter: FC<Props> = ({ defaultValues, updateSelectedValue }) => {
  const [selectedOptions, setSelectedOptions] = useState<CountryFilterOption[]>([]);
  const { countries } = useFetchCountries()

  const options = useMemo(() => countries.map(country => {
    return { value: +country.id, label: country.name }
  }), [countries])

  const handleChange = (selected: any) => {
    console.log('SELECTED COUNTRY');
    setSelectedOptions(selected);

    const values = (selected as CountryFilterOption[]).map((item) => item.value).join(',');

    updateSelectedValue(values);
  };

    useEffect(() => {
    if (defaultValues) {
      const filterOptions: CountryFilterOption[] = [];
      defaultValues.split(',').forEach((item) => {
        const optionExists = options.find((option) => option.value === parseInt(item));
        if (optionExists) {
          filterOptions.push(optionExists);
        }
      });
      setSelectedOptions(filterOptions);
    }
  }, [defaultValues, options]);

  return (
    <ReactSelect
      options={options}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      components={{
        Option: MultiSelectOption,
      }}
      onChange={handleChange}
      value={selectedOptions}
      isClearable={false}
    />
  );
}
